import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH AGREEMENTS VERSION TO EDIT ********************
export const fetchAgreementsVersion = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_AGREEMENTS_VERSION_LOADING,
			payload: true
		});

		const { data } = await services.get(`/agreements/versions/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_AGREEMENTS_VERSION_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_AGREEMENTS_VERSION_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
